/**
       * Creates a JSON-LD script element containing breadcrumb data and appends it to the head of the HTML document.
       */
function createBreadcrumbList() {
    /**
     * Extracts breadcrumb data from the HTML document.
     * returns {Object} The breadcrumb data in the form of a JSON-LD BreadcrumbList.
     */
    function extractBreadcrumbData() {
        // Initialize the breadcrumbList object
        var breadcrumbList = {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": []
        };

        // Get all breadcrumb items in the document
        var breadcrumbItems = document.querySelectorAll('.breadcrumb__item');

        // Iterate over each breadcrumb item
        for (var i = 0; i < breadcrumbItems.length; i++) {
            var breadcrumbItem = breadcrumbItems[i];
            var linkElement = breadcrumbItem.querySelector('.breadcrumb__link');

            if (linkElement) {
                // Extract the name and item values
                var name = linkElement.querySelector('span').textContent;
                var item = linkElement.getAttribute('href');

                // Create the breadcrumbData object
                var breadcrumbData = {
                    "@type": "ListItem",
                    "position": i + 1, // Calculate position dynamically
                    "name": name,
                    "item": new URL(item, window.location.href).href
                };

                // Add the breadcrumbData object to the itemListElement array
                breadcrumbList.itemListElement.push(breadcrumbData);
            }
        }

        return breadcrumbList;
    }

    // Extract breadcrumb data from the document
    var breadcrumbData = extractBreadcrumbData();
    if (breadcrumbData.itemListElement.length >0) {

        // Create a JSON-LD script element
        var scriptElement = document.createElement("script");
        scriptElement.type = "application/ld+json";
        scriptElement.text = JSON.stringify(breadcrumbData);

        // Append the script element to the head of the HTML document
        var head = document.head;
        head.appendChild(scriptElement);
    }
}

createBreadcrumbList();